import * as React from "react";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";
import { drawerWidth } from "../../constants";
import MenuIcon from "@material-ui/icons/Menu";
import { colors } from "../../theme";
import MenuUsuario from "./MenuUsuario";

type Props = {
  drawerOpen: boolean;
  onDrawerToggle: () => void;
};
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Header: React.FC<Props> = (props) => {
  const { onDrawerToggle } = props;

  const [ancora, setAncora] = React.useState<null | HTMLElement>(null);
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  return (
    <AppBar position="fixed" style={{ background: colors.drawer }}>
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <IconButton onClick={onDrawerToggle}>
          <MenuIcon style={{ color: "white" }} />
        </IconButton>

        <Typography
          variant="h5"
          noWrap
          component="div"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            letterSpacing: "0.5px",
            color: "white",
          }}
        >
          <span style={{ color: "#ffffff" }}>Trip</span>
          <span style={{ color: "#FF5252" }}>Log</span>
        </Typography>

        <MenuUsuario
          ancora={ancora}
          setAncora={setAncora}
          menuIsOpen={menuIsOpen}
          setMenuIsOpen={setMenuIsOpen}
        />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
